/** Dedicated customer portal hostname (Clarity One). */
export const CLARITY_ONE_HOSTNAME = "one.claritygroup.com.sg";

export function normalizeHostname(hostname: string): string {
  return hostname.trim().toLowerCase().split(":")[0] ?? "";
}

export function isClarityOneHostname(hostname: string): boolean {
  return normalizeHostname(hostname) === CLARITY_ONE_HOSTNAME;
}

/** User-facing paths allowed on the Clarity One domain. */
export function isClarityOnePublicPath(pathname: string): boolean {
  const path = pathname.split("?")[0] ?? pathname;
  if (path === "/" || path === "/login" || path === "/home") return true;
  if (path.startsWith("/auth/verify/")) return true;
  if (path.startsWith("/auth/impersonate/")) return true;
  if (path === "/wallet/kaleidescape") return true;
  if (path === "/account" || path === "/account/statement" || path.startsWith("/account/")) return true;
  if (path === "/service" || path.startsWith("/service/")) return true;
  if (path === "/proposals" || path.startsWith("/proposals/")) return true;
  if (path === "/documents" || path.startsWith("/documents/")) return true;
  if (path === "/invoices" || path.startsWith("/invoices/")) return true;
  if (path === "/warranty" || path.startsWith("/warranty/")) return true;
  if (path.startsWith("/vo/")) return true;
  // Anonymous share folder — viewing must not require Clarity One login.
  if (path.startsWith("/share/")) return true;
  return false;
}

/** Same path set used for localhost dev routing (VITE_CLARITY_ONE_DEV). */
export function isClarityOneCustomerPath(pathname: string): boolean {
  return isClarityOnePublicPath(pathname);
}

/** Asset and API paths required for the Clarity One SPA to function. */
export function isClarityOneInfrastructurePath(pathname: string): boolean {
  const path = pathname.split("?")[0] ?? pathname;
  if (path.startsWith("/assets/")) return true;
  if (path.startsWith("/api/trpc")) return true;
  if (path.startsWith("/api/digital-card-assets")) return true;
  if (path.startsWith("/api/warranty-images")) return true;
  if (path.startsWith("/api/payment-receipts/")) return true;
  if (path === "/favicon.ico" || path.startsWith("/favicon.")) return true;
  if (path.startsWith("/@vite") || path.startsWith("/@fs/") || path.startsWith("/src/")) return true;
  if (path.startsWith("/node_modules/")) return true;
  return false;
}

export function shouldBlockPathOnClarityOne(pathname: string): boolean {
  if (isClarityOneInfrastructurePath(pathname)) return false;
  return !isClarityOnePublicPath(pathname);
}
